import { useState } from "react";
import { wrapperRequests } from "../../../services/api";
import { downloadFile } from "../../../shared/DownloadFile";

export default function useAutoPrintCSVDownload() {
  const [loading, setLoading] = useState(false);

  function generateReportFileName(tagNames: string) {
    const formattedTagName = tagNames.replaceAll(" ", "_");
    return `auto_print_labels_${formattedTagName}.csv`;
  }

  const downloadCSV = async (tagNames: string) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    try {
      const url = `products/auto-prints/generate-csv?tagNames=${tagNames}`;

      const response = await wrapperRequests(url, "GET", {
        responseType: "blob",
        timeout: 900000,
      });

      downloadFile(response.data, {
        fileName: generateReportFileName(tagNames),
        mimeType: "text/csv",
      });

      return Promise.resolve("CSV downloaded successfully");
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      console.error("Error downloading auto-print CSV:", err);

      let errorMessage = "Error downloading CSV file";

      try {
        if (err?.response?.data instanceof Blob) {
          const text = await err.response.data.text();
          errorMessage = JSON.parse(text).message || errorMessage;
        } else {
          errorMessage =
            err?.response?.data?.message ||
            err?.response?.statusText ||
            err?.message ||
            errorMessage;
        }
      } catch {
        errorMessage =
          err?.response?.statusText || err?.message || errorMessage;
      }
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    downloadCSV,
  };
}
